import { spaceCadet } from '@cogneed/react-utils';
import HistoryIcon from '@mui/icons-material/HistoryRounded';
import { Box, List, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import DetectionGroupListItem from './Components/DetectionGroupListItem';
import StyledBox from './styles';
import useDetectionGroups from '../../../../Contexts/DetectionGroupContext/useDetectionGroups';
import { DetectionGroup } from '../../../../Contexts/DetectionGroupContext';

interface InnerDetectionListProps {
  detectionGroups: DetectionGroup[];
}

function InnerDetectionList(props: InnerDetectionListProps) {
  const { t } = useTranslation();
  const { detectionGroups } = props;
  if (detectionGroups.length === 0) {
    return (
      <Typography style={{
        fontSize: 10, lineHeight: 1.6, color: spaceCadet[400], marginLeft: 4,
      }}
      >
        {t('detections.empty')}
      </Typography>
    );
  }
  return (
    <List disablePadding>
      {detectionGroups.map((d, index) => <DetectionGroupListItem key={d.id} detectionGroup={d} index={index} />)}
    </List>
  );
}

interface DetectionListProps {
  hasClient: boolean;
}

export default function DetectionList(props: DetectionListProps) {
  const { hasClient } = props;
  const detectionGroups = useDetectionGroups();
  const { t } = useTranslation();
  return (
    <StyledBox hasClient={hasClient}>
      <Typography variant="h2">
        <HistoryIcon />
        {t('detections.live')}
      </Typography>
      <Box>
        <InnerDetectionList detectionGroups={detectionGroups} />
      </Box>
    </StyledBox>
  );
}
